import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * A 32px copyright strip (Figma "Bottom app bar", node 780:1138), used below the access denied
 * card. It has no fill of its own, so it sits on the page background in both themes.
 *
 * The year is read from the clock rather than hard coded so the notice does not go stale.
 */
@Component({
  selector: 'app-footer',
  imports: [TranslatePipe],
  templateUrl: './footer.html',
  host: { class: 'block' },
})
export class Footer {
  public readonly year = new Date().getFullYear();
}
